var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useRef, useCallback } from 'react';
import omit from 'lodash/omit';
import { i18n } from '@lingui/core';
export var usePresetFileHandlers = function (_a) {
    var gridName = _a.gridName, gridActions = _a.gridActions, gridSelectors = _a.gridSelectors;
    var fileInputRef = useRef(null);
    var handleExportPresets = useCallback(function () {
        if (!gridName)
            return;
        var gridConfig = { gridName: gridName };
        var data = __assign(__assign({}, gridSelectors.presets), { _: gridConfig });
        var blob = new Blob([JSON.stringify(data, null, 2)], {
            type: 'application/json'
        });
        var link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = "".concat(gridName, "Presets.json");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }, [gridName, gridSelectors.presets]);
    var handleImportPresets = useCallback(function (event) {
        var _a;
        if (!gridName)
            return;
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        var reader = new FileReader();
        reader.readAsText(file);
        reader.onload = function (e) {
            var _a, _b;
            try {
                var fileContent = JSON.parse((_a = e.target) === null || _a === void 0 ? void 0 : _a.result);
                var gridConfig = fileContent._;
                if (gridConfig && gridConfig.gridName !== gridName) {
                    throw new Error(i18n._({ id: 'dataGrid.importPresets.gridNameNotSame', 'message': 'Grid name in file is not the same as current grid.' }));
                }
                (_b = gridActions.setPresets) === null || _b === void 0 ? void 0 : _b.call(gridActions, omit(fileContent, '_'));
            }
            catch (error) {
                console.warn(error);
                alert(i18n._({ id: 'dataGrid.importPresets.error', 'message': 'Error with importing files.' }) + error);
            }
            finally {
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        };
    }, [gridName]);
    var handleImportButtonClick = useCallback(function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    return {
        fileInputRef: fileInputRef,
        handleImportPresets: handleImportPresets,
        handleExportPresets: handleExportPresets,
        handleImportButtonClick: handleImportButtonClick
    };
};
